import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { Order } from '../Order'

@InputType()
export class GetOrderWeightArgs extends ActionArgs {
  @Field(() => Order)
  order?: Order

  @Field(() => String)
  orderId?: string
}

export interface IGetOrderWeight extends IAction<number, GetOrderWeightArgs> {}
